import React from 'react';
import { CheckboxField } from '@aws-amplify/ui-react';

const StatelessCheckBoxField = (props) => {
    return (
        <CheckboxField
            key={`${props.Name}_chkBox_${props.index}`}
            checked={props.value === 1}
            onChange={(e) => props.handleChange(e)}
            label={props.Name}
            name={props.Name + '_' + props.index}
            id={props.Name + '_' + props.index} />
    )
}

export default StatelessCheckBoxField;